import { FormItem } from '../../../../../../commons/Form/Form.types';
import { DashboardProspectsDIRFiltersFormSchema } from './DashboardProspectsDIRFiltersForm.types';

export const dashboardProspectsDIRFiltersFormData: FormItem<DashboardProspectsDIRFiltersFormSchema>[][] =
  [
    [
      {
        name: 'commercialIds',
        placeholder: 'Filtrer prospects par commercial...',
        label: 'Commerciaux',
        type: 'select',
        id: 'commercial-ids',
      },
    ],
  ];
